import type { BubblePointPressurePSIACalculator } from "../../d";
import { solutionGasRsoCalculator } from "./solutionGasRsoCalculator";

export const bubblePointPressurePSIACalculator: BubblePointPressurePSIACalculator =
  params => {
    const {
      gasSpecificGravity,
      oilAPI,
      temperatureInRankine,
      solutionGasRsoAtReservoir
    } = params;
    const { rsc1, rsc2, rsc3 } = solutionGasRsoCalculator(params);

    // D41: =J15/(D33*D8*EXP(D35*(D7/D15))))**(1/D34)
    const bubblePointPressurePSIA =
      (solutionGasRsoAtReservoir /
        (rsc1 *
          gasSpecificGravity *
          Math.exp(rsc3 * (oilAPI / temperatureInRankine)))) **
      (1 / rsc2);

    return {
      rsc1,
      rsc2,
      rsc3,
      solutionGasRsoAtReservoir,
      gasSpecificGravity,
      oilAPI,
      temperatureInRankine,
      bubblePointPressurePSIA
    };
  };
